<template>
	<div style="height: 84vh;">
		<ListingButton :lists="lists" @add='add' @dele='BatchDelete()'></ListingButton>
		<MyTable :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete" @Currentchange="contractlistcontractlist"
			style="margin: 1rem;"></MyTable>
		<MyDialog :item="EditValue" :DialogTitle="DialogTitle" @changedia="changedia"
			:centerDialogVisible="centerDialogVisible"></MyDialog>
	</div>
</template>

<script>
	import ListingButton from "@/components/Listing_Button/index.vue"
	import MyTable from "@/components/MyTable/index.vue"
	import MyDialog from "@/components/My_dialog/index.vue"
	import {
		activity_list,
		activity_delete
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: 'management',
				lists: [{
					name: '添加',
					type: 'primary',
					icon: 'el-icon-plus',
					funt: 'add'
				}, {
					name: '删除',
					type: 'danger',
					icon: 'el-icon-delete',
					funt: 'dele'
				}, ],
				tableData: [],
				table_label: [{
					label: ' ID',
					value: 'id'
				}, {
					label: '活动名称',
					value: 'name'
				}, {
					label: '活动类型',
					value: 'type'
				}, {
					label: '地址',
					value: 'address'
				}, {
					label: '缩略图',
					value: 'dir'
				}, {
					label: '时间',
					value: 'time'
				}, {
					label: '状态',
					value: 'status'
				}],
				total: null,
				multipleSelection: [],
				EditValue: '',
				centerDialogVisible: false,
				DialogTitle: '',
				data: {
					page: 1,
					limit: 15
				}
			}
		},
		methods: {
			contractlistcontractlist(value) {
				this.data.page = value ? value : this.data.page
				activity_list(this.data).then(res => {
					console.log('res', res);
					if (res.status == 200) {
						this.tableData = res.data.list
						this.total = res.data.count
						if (res.__requestPayload) {
							this.data = res.__requestPayload
						}
					}
				})
			},
			add() {
				this.centerDialogVisible = true
				this.DialogTitle = '添加活动'
			},
			//点击编辑
			Edit(value) {
				console.log('Edit', value);
				this.EditValue = value
				this.centerDialogVisible = true
				this.DialogTitle = '活动编辑'
			},
			// 批量删除的数组
			DeleteValue(value) {
				this.multipleSelection = value
			},
			// 批量删除的方法
			BatchDelete() {
				console.log(this.multipleSelection);
				activity_delete({
					ids: this.multipleSelection
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
			},
			// 点击删除
			Delete(value) {
				console.log("Delete", value.id);
				activity_delete({
					ids: value.id
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
			},
			changedia(value) {
				this.centerDialogVisible = value
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			}
		},
		created() {
			const isTabChangeStr = sessionStorage.getItem('setIsTabChange');
			const isTabChange = isTabChangeStr === 'true';
			if (!isTabChange) {
				this.contractlistcontractlist()
			} else {
				const res = JSON.parse(sessionStorage.getItem('res'))
				this.tableData = res.data.list
				this.total = res.data.count
				sessionStorage.setItem('setIsTabChange', false);

			}

		},
		components: {
			MyTable,
			ListingButton,
			MyDialog
		}
	}
</script>

<style scoped>

</style>